// extracted by mini-css-extract-plugin
export default {"iconWrapper":"CustomIcon_iconWrapper__qYr7t"};